import React, {useState} from "react";
import {colorFunctions} from "../constants/colors";

export default function OvalButton({label, clickFunction}){
	
	const [thisBackground, setThisBackground] = useState("");
	const [thisForeground, setThisForeground] = useState("black");
	
	const handleClick = () => {
		if(clickFunction){
			clickFunction();
		}
	};
	
	const handleMouseOver = () => {
		setThisBackground(colorFunctions.getSecondaryColor());
		setThisForeground("white");
	};
	
	const handleMouseLeave = () => {
		setThisBackground("");
		setThisForeground("black");
	}
	
	const ovalButton = {
		display:"flex",
		width:"150px",
		height:"40px",
		border:"1px solid " + colorFunctions.getSecondaryColor(),
		alignItems:"center",
		justifyContent:"space-around",
		fontSize:"14px",
		borderRadius:"20px",
		margin:"10px",
		backgroundColor:thisBackground,
		cursor:"pointer",
		color:thisForeground
	};
	
	return (
		<div style={ovalButton} onClick={handleClick} onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
			{label}
		</div>
	);
}